/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { FiRefreshCcw } from "react-icons/fi";
import authservice from "../services/auth.services";

const CaptchaModal = (props) => {
  const vendorId = props?.vendorID;
  const [webUrl, setWebUrl] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [inputCaptcha, setInputCaptcha] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [captchaLoading, setCaptchaLoading] = useState(false);

  const handleCaptchaChange = (e) => {
    const inputCaptchaValue = e.target.value;
    setInputCaptcha(inputCaptchaValue);
    if (captchaError) {
      setCaptchaError("");
    }
  };

  const generateCaptchaCode = async () => {
    const url = "generateCaptchaCode";
    const jsonData = { type: "WEB_URL" };
    try {
      setCaptchaLoading(true);
      authservice.postJsonData(url, jsonData).then((response) => {
        if (response.apiResponseCode === "1001") {
          setCaptcha(response.captchaCode);
        }
      });
      setCaptchaLoading(false);
    } catch (error) {
      console.warn("fetch captcha error:", error);
      setCaptchaLoading(false);
    }
  };

  const getWebUrl = async () => {
    const url = "getwebUrl";
    const jsonData = {
      captchaCode: inputCaptcha,
      vendorID: vendorId.toString(),
    };
    try {
      authservice.postJsonData(url, jsonData).then((response) => {
        if (response.apiResponseCode === "1001") {
          setWebUrl(response.webUrl);
        }
      });
    } catch (error) {
      console.warn("fetch weburl error:", error);
    }
  };

  const handleVisitStore = () => {
    if (!inputCaptcha) {
      setCaptchaError("Captcha is required");
    } else if (inputCaptcha !== captcha) {
      setCaptchaError("Invalid Captcha");
    } else if (inputCaptcha === captcha && webUrl) {
      const formattedUrl = webUrl.startsWith("http")
        ? webUrl
        : `https://${webUrl}`;
      const newTab = window.open(formattedUrl, "_blank");
      if (newTab) newTab.focus();
      setCaptchaError("");
      props.setVisitStoreClicked(false);
    }
  };

  const refreshCaptcha = () => {
    generateCaptchaCode();
    setCaptchaError("");
    setInputCaptcha("");
  };

  useEffect(() => {
    if (props?.visitStoreClicked) {
      generateCaptchaCode();
    }
  }, [props?.visitStoreClicked]);

  useEffect(() => {
    if (inputCaptcha && captcha && inputCaptcha === captcha) {
      getWebUrl();
    }
  }, [inputCaptcha, captcha]);

  return (
    <CModal
      className="modal-wrapper"
      visible={props?.visitStoreClicked}
      size="md"
      backdrop="static"
      keyboard={false}
      onClose={() => {
        props.setVisitStoreClicked(false);
        setInputCaptcha("");
        setCaptcha("");
        setCaptchaError("");
      }}
    >
      <CModalHeader className="modal-header">
        <CModalTitle className="modal-title">Enter Captcha</CModalTitle>
      </CModalHeader>

      <CModalBody className="modal-body pb-0">
        <div className="captcha-wrapper">
          <div className="captcha-text-and-input">
            <div className="captcha-text">
              <p>{captchaLoading ? "Loading..." : captcha}</p>
            </div>
            <button
              type="button"
              onClick={refreshCaptcha}
              className="captcha-refresh-btn"
            >
              <FiRefreshCcw />
            </button>
          </div>
          <div className="captcha-input-div">
            <input
              className="captcha-input"
              type="text"
              placeholder="Enter Captcha Code"
              value={inputCaptcha}
              onChange={handleCaptchaChange}
              maxLength={6}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleVisitStore();
                }
              }}
            />
          </div>

          {captchaError && (
            <p className="text-danger captchaError">{captchaError}</p>
          )}
        </div>
      </CModalBody>

      <CModalFooter className="modal-footer ">
        <button
          type="button"
          className="visit-store-btn"
          onClick={handleVisitStore}
        >
          Visit Store
        </button>
      </CModalFooter>
    </CModal>
  );
};

export default CaptchaModal;
